import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchComplaintsApi,
  addComplaintApi,
  updateComplaintApi,
  deleteComplaintApi,
} from "../services/ComplaintService";

// Fetch all complaints and dropdown data
export const fetchComplaints = createAsyncThunk(
  "complaints/fetchComplaints",
  async (searchText = "") => {
    const response = await fetchComplaintsApi(searchText);
    return response;
  }
);

// Add a new complaint
export const addComplaint = createAsyncThunk(
  "complaints/addComplaint",
  async (complaintData) => {
    const response = await addComplaintApi(complaintData);
    if (response.head.code === 200) {
      return response.head.msg;
    } else {
      throw new Error(response.head.msg);
    }
  }
);

// Update a complaint
export const updateComplaint = createAsyncThunk(
  "complaints/updateComplaint",
  async (complaintData) => {
    const response = await updateComplaintApi(complaintData);
    if (response.head.code === 200) {
      return response.head.msg;
    } else {
      throw new Error(response.head.msg);
    }
  }
);

// Delete a complaint
export const deleteComplaint = createAsyncThunk(
  "complaints/deleteComplaint",
  async ({ complaintId, currentUserId }) => {
    const response = await deleteComplaintApi(complaintId, currentUserId);
    if (response.head.code === 200) {
      return response.head.msg;
    } else {
      throw new Error(response.head.msg);
    }
  }
);

const complaintSlice = createSlice({
  name: "complaints",
  initialState: {
    complaints: [],
    customers: [],
    staff: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch complaints
      .addCase(fetchComplaints.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchComplaints.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.complaints = action.payload.complaints || [];
        state.customers = action.payload.customers || [];
        state.staff = action.payload.staff || [];
      })
      .addCase(fetchComplaints.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      // Add complaint
      .addCase(addComplaint.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addComplaint.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(addComplaint.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      // Update complaint
      .addCase(updateComplaint.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateComplaint.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateComplaint.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      // Delete complaint
      .addCase(deleteComplaint.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteComplaint.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(deleteComplaint.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default complaintSlice.reducer;
